import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Micro } from '@vds/typography';
import { selectStateCache } from '../@selectors';
import { selectStateCache as selectCheckoutStateCache } from '../../@Redux/selectors/checkout.selectors';
import './desktopCart.css';
import { useDueMonthlyListHooks } from '../@Redux/OrderSummary.hooks';
import PriceView from './PriceView';

const DueMonthlyProduct = () => {
  const stateCacheCart = useSelector((state) => selectStateCache(state), shallowEqual);
  const stateCacheCheckout = useSelector((state) => selectCheckoutStateCache(state), shallowEqual);
  const { dueMonthlyList, dueMonthlyTaxList } = useDueMonthlyListHooks(stateCacheCart,stateCacheCheckout);
  const renderHTMLContent = (item) => (
    <div style={{ marginBottom: '1rem'}}>
      <div key={item?.name} style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p className="content_container" style={{ width: '75%' }}>
          {item?.displayName}
        </p>
        <PriceView item= {item} />
      </div>
      {item?.subtitleText && (
        <Micro size="large" color="#6F7171">
          {item.subtitleText}
        </Micro>
      )}
    </div>
  );
  return (
    <div className=''>
      {dueMonthlyList.dueMonValues.map((item) => renderHTMLContent(item))}
      {dueMonthlyTaxList && renderHTMLContent(dueMonthlyTaxList)}
    </div>
  );
};

export default DueMonthlyProduct;
